import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getEligibleAppsForFreeTrialRequest = {};
var _getEligibleAppsForFreeTrialResponse = {};
function resolveComWixAppmarketAppSubscriptionsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getEligibleAppsForFreeTrial(payload) {
    var _a = serializer(_getEligibleAppsForFreeTrialRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEligibleAppsForFreeTrialResponse, {}).fromJSON;
    function __getEligibleAppsForFreeTrial(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_subscriptions',
            method: 'GET',
            methodFqn: 'com.wix.appmarket.AppSubscriptionsService.GetEligibleAppsForFreeTrial',
            url: resolveComWixAppmarketAppSubscriptionsServiceUrl({
                protoPath: '/v1/eligible-apps-for-free-trial',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEligibleAppsForFreeTrial.fromReq = fromReq;
    __getEligibleAppsForFreeTrial.__isAmbassador = true;
    return __getEligibleAppsForFreeTrial;
}
//# sourceMappingURL=http.impl.js.map